import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { Trash2, MoreVertical } from 'feather-icons-react';
import { IUser } from 'src/services/types';
import { useState } from 'react';
import { ConfirmUsersDeleteModal } from './ConfirmUsersDeleteModal';
import { toast } from 'react-toastify';

interface IProps {
    users: IUser[]; // Replace 'any' with the actual type of 'item'
    onRemoveSelectedUser: (id: string) => void; // Function to remove a selected user by ID
    onRefresh: () => void; // Function to refresh the user list
}
export const DropdownActionsSelectedUsers = ({ 
    users, 
    onRemoveSelectedUser,
    onRefresh,
}: IProps) => {

    const [showDeletedModal, setShowDeletedModal] = useState(false);
    const onDelete = async () => {
        if (users.length === 0){
            toast.error('Please select at least one user to delete');
            return;
        }
        setShowDeletedModal(true);
    }
    
  return (
    <>
        <UncontrolledDropdown
            className="me-2"
            direction="down"
        >
            <DropdownToggle
            caret
            className="btn btn-soft-success btn-sm waves-effect waves-light"
            >
                <div className='px-3'>
                    <span>Actions </span>
                    <MoreVertical size={'16px'}/>
                </div>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem onClick={() => onDelete()}>
                    <div className="d-flex align-items-center gap-2">
                    <Trash2 size="16"/>
                    <span>Delete users</span>
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
        
        <ConfirmUsersDeleteModal
            show={showDeletedModal}
            onClose={() => setShowDeletedModal(false)}
            onRefresh={() => onRefresh()}
            onRemoveSelectedUser={onRemoveSelectedUser}
            users={users}
        />
    </>
  )
}